import { render } from "./EditPreferencesThird.vue?vue&type=template&id=b82adb60&scoped=true"
import script from "./EditPreferencesThird.vue?vue&type=script&lang=js"
export * from "./EditPreferencesThird.vue?vue&type=script&lang=js"

import "./EditPreferencesThird.vue?vue&type=style&index=0&id=b82adb60&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82adb60"]])

export default __exports__